module.exports = __webpack_public_path__ + "static/media/shoyu-round-trans.5cc621e6.png";